import { States } from '@core/types';
import React, { FC, Fragment } from 'react';
import { connect } from 'react-redux';
import { t } from './index';

interface IProps {
  translations?: States.TranslationsState;
  resourceString: string;
}

const Translate: FC<IProps> = ({ translations, resourceString }) => {
  if (!translations || translations.isLoading || translations.values.length === 0) {
    return null;
  }

  return <Fragment>{t(resourceString)}</Fragment>;
};

const mapStateToProps = (state: States.RootState) => ({
  translations: state.translations,
});

// const mapDispatchToProps = dispatch => ({
// });

export default connect(mapStateToProps, null)(Translate);
